module.exports = __webpack_public_path__ + "assets/img/zhejiang.23f7a0bd.png";